<template>
  <div>
    <QuestionTitle :data="data" v-if="data.que_type != 7" />
    <div>
      <!-- 单选 -->
      <QuestionRadio
        v-if="data.que_type === 0"
        :data="data"
        @change="bindChange"
        :theme="theme"
      ></QuestionRadio>
      <!-- 多选 -->
      <QuestionCheckbox
        v-if="data.que_type == 1"
        :data="data"
        @change="bindChange"
        :theme="theme"
      >
      </QuestionCheckbox>
      <!-- 问答 -->
      <QA
        v-if="[2, 3].includes(data.que_type)"
        :data="data"
        @change="bindChange"
        :theme="theme"
      ></QA>
      <QuestionSelect
        v-if="data.que_type == 4"
        :data="data"
        @change="bindChange"
        :theme="theme"
      />
      <QuestionImagePreview
        v-if="data.que_type == 7"
        :step="data.step"
        :data="data"
        @change="bindChange"
        :theme="theme"
      />
      <!-- 地区 -->
      <QuestionArea
        v-if="data.que_type == 8"
        :data="data"
        @change="bindChange"
        :theme="theme"
      />
      <QuestionRuler
        class="question-ruler"
        v-if="data.que_type == 5"
        :data="data"
        :question="question"
        @change="bindChange"
        :theme="theme"
      />
      <QuestionTime
        v-if="data.que_type == 6"
        :data="data"
        @change="bindChange"
        :theme="theme"
      />
    </div>
    <div class="question-tips" v-if="questionTips.length">
      <div
        class="question-item"
        v-for="(item, index) in questionTips"
        :key="index"
      >
        <div class="item-desc" v-html="item.desc"></div>
      </div>
    </div>
  </div>
</template>
<script>
import QuestionTitle from './question/q-title.vue'
import QuestionRadio from './radio.vue'
import QuestionCheckbox from './checkbox.vue'
import QuestionRuler from './ruler/index.vue'
import QuestionTime from './time/index.vue'
import QA from './qa/qa.vue'
import QuestionArea from './area/area.vue'
import QuestionImagePreview from './image-preview.vue'
import QuestionSelect from './question-select.vue'
export default {
  components: {
    QuestionTitle,
    QuestionRadio,
    QuestionCheckbox,
    QA,
    QuestionRuler,
    QuestionTime,
    QuestionArea,
    QuestionImagePreview,
    QuestionSelect
  },
  props: {
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    question: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    questionTips() {
      let arr = []
      if (Array.isArray(this.data.options)) {
        this.data.options.map((item) => {
          if (item.introduce) {
            arr.push({
              desc: item.introduce
            })
          }
        })
      }
      return arr
    }
  },
  methods: {
    bindChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.question-tips {
  margin-top: 20px;
  padding: 0px 16px;

  .question-item {
    .item-desc {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #bd885c;
      line-height: 18px;

      .bold {
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #bd885c;
        line-height: 18px;
      }
    }
  }
}

.question-ruler {
  width: 100%;
}
</style>
